<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title class="greyk lighten-4k">
          Expense
          <v-btn
            icon
            color="primary"
            @click="openExForm()"
            class="elevation-5 ml-3"
          >
            <v-icon>add</v-icon>
          </v-btn>

          <!-- <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn color="success" @click="exportAllExpense()" v-on="on">Excel</v-btn>
            </template>
            <span>Export all expense this term to excel</span>
          </v-tooltip>-->
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
            style="max-width: 40%"
          ></v-text-field>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12>
              <v-data-table
                :headers="exp_headers"
                :items="expenses"
                class="elevation-0"
                :search="search"
                :loading="loading"
              >
                <template v-slot:item.sn="{ item, index }">
                  {{ index + 1 }}
                </template>
                <template v-slot:item.ledger_account="{ item }">
                  {{
                    item.ledgeracc && item.ledgeracc.name
                      ? item.ledgeracc.name
                      : "N/A"
                  }}
                </template>
                <template v-slot:item.dr="{ item }">
                  {{ parseFloat(item.dr) | currency }}
                </template>
                <template v-slot:item.cr="{ item }">
                  {{ parseFloat(item.cr) | currency }}
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-btn text icon color="blue" @click="editexpense(item)">
                        <v-icon>edit</v-icon>
                      </v-btn>
                    </v-flex>

                    <v-flex xs6>
                      <v-btn
                        text
                        icon
                        color="pink"
                        @click="deleteexpense(item, index)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </template>

                <!-- <template v-slot:items="props">
                  <td class="text-xs-center">{{ props.index + 1 }}</td>
                  <td
                    class="text-xs-center"
                  >{{ props.item.ledgeracc&&props.item.ledgeracc.name?props.item.ledgeracc.name:'N/A' }}</td>
                  <td class="text-xs-center">{{ props.item.description }}</td>
                  <td class="text-xs-center">{{ props.item.dr | currency }}</td>
                  <td class="text-xs-center">{{ props.item.cr | currency }}</td>
                  <td class="text-xs-center">{{ props.item.jdate }}</td>
                  <td class="text-xs-center">{{ props.item.recorded_by.name }}</td>

                  <td class="text-xs-center">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-btn text icon color="blue" @click="editexpense(props.item)">
                          <v-icon>edit</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs6>
                        <v-btn
                          text
                          icon
                          color="pink"
                          @click="deleteexpense(props.item,props.index)"
                        >
                          <v-icon>delete</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </td>
                </template> -->
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <!--dialog form to add and edit expense begins-->
      <inc-dialog ref="incfm">
        <template v-slot:modal-title>{{ fm_title }}</template>

        <template v-slot:modal-content>
          <v-form ref="form">
            <v-autocomplete
              :items="ledgeraccs"
              item-text="name"
              item-value="id"
              label="Ledger Account"
              prepend-icon="book"
              v-model="expense_model.ledgeracc_id"
              :rules="valid_rules.required"
            />
            <v-text-field
              label="Description/Reference"
              prepend-icon="description"
              v-model="expense_model.description"
              :rules="valid_rules.required"
            />

            <v-text-field
              label="Debit (Expense Total Amount)"
              v-model="expense_model.dr"
              :rules="valid_rules.required"
              prepend-icon="money"
              type="number"
              step="any"
            />

            <v-text-field
              label="Credit (Total Paid on Expense)"
              v-model="expense_model.cr"
              :rules="cr_dr_rule"
              prepend-icon="money"
              type="number"
              step="any"
            />

            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="expense_model.jdate"
              persistent
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="expense_model.jdate"
                  label="Date"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  :rules="valid_rules.required"
                ></v-text-field>
              </template>
              <v-date-picker v-model="expense_model.jdate" scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="modal = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(expense_model.jdate)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>

            <v-checkbox
              label="Record Corresponding Bank Transaction (debit)"
              v-model="expense_model.cbt"
              v-if="editedIndex < 0"
            />

            <v-autocomplete
              v-if="expense_model.cbt == true"
              :items="bacts"
              item-text="bname"
              item-value="id"
              label="Select Bank Account"
              prepend-icon="money"
              v-model="expense_model.bankacc_id"
              :rules="valid_rules.required"
            />
          </v-form>
        </template>

        <template v-slot:modal-actions>
          <v-btn class="error" text @click.stop="closeExForm()">Close</v-btn>
          <v-btn class="success" text @click="saveexpense()">Save</v-btn>
        </template>
      </inc-dialog>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import Modal from "../shared/modal_dialog";
import { json2excel, excel2json } from "js2excel";
export default {
  layout: "accounts",
  name: "expenses-view",
  metaInfo() {
    return { title: this.$t("expenses") };
  },
  components: {
    "inc-dialog": Modal,
  },
  data() {
    return {
      editedIndex: -1,
      search: "",
      showD: false,
      modal: false,
      fm_title: "",
      valid_rules: {
        required: [(v) => !!v || "this field is required"],
      },
      expense_model: {
        ledgeracc_id: "",
        description: "",
        dr: "0.00",
        cr: "0.00",
        jdate: new Date().toISOString().substr(0, 10),
        cbt: false,
        bankacc_id: "",
      },
      exp_headers: [
        {
          text: "SN",
          align: "center",
          sortable: true,
          value: "sn",
        },
        {
          text: "Ledger Account",
          align: "center",
          sortable: false,
          value: "ledger_account",
        },
        {
          text: "Description/Ref.",
          align: "center",
          sortable: false,
          value: "description",
        },
        {
          text: "Debit(dr)",
          align: "center",
          sortable: true,
          value: "dr",
        },
        {
          text: "Credit(cr)",
          align: "center",
          sortable: true,
          value: "cr",
        },
        {
          text: "Date",
          align: "center",
          sortable: false,
          value: "jdate",
        },
        {
          text: "Recorded By",
          align: "center",
          sortable: false,
          value: "recorded_by.name",
        },

        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions",
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch("expenses/getAll");
    this.$store.dispatch("bankaccs/getAll");
  },
  computed: {
    ...mapGetters({
      expenses: "expenses/EXPENSES",
      ledgeraccs: "expenses/EXPENSE_LEDGERACCS",
      experrors: "expenses/EXPENSE_ERROR",
      loading: "expenses/EXPENSE_LOADING",

      bankaccs: "bankaccs/BANKACCS",
      baloading: "bankaccs/BANKACC_LOADING",
      baerrors: "bankaccs/BANKACC_ERROR",
    }),
    cr_dr_rule() {
      return [
        parseFloat(this.expense_model.dr) >=
          parseFloat(this.expense_model.cr) ||
          "Credit can not be greater than debit for this expense",
        ...this.valid_rules.required,
      ];
    },

    bacts() {
      if (this.bankaccs) {
        let baccs = this.bankaccs.map((b) => {
          return {
            bname: b.bank_name + " (" + b.acc_num + ")",
            ...b,
          };
        });

        return baccs;
      }

      return [];
    },
  },
  methods: {
    exportAllExpense() {
      if (!confirm("Click okay to confirm list export or cancel.")) {
        //confirm you want to send this reminder
        return;
      }

      let data = this.expenses.map((s) => {
        return {
          "Ledger Account": s.ledgeracc.name,
          Description: s.description,
          "Debit(dr)": s.dr,
          "Credit(cr)": s.cr,
          Date: s.jdate,
          "Recorded By": s.recorded_by ? s.recorded_by.name : "N/A",
        };
      });

      try {
        json2excel({
          data,
          name: "expenses-" + new Date().toISOString().substr(0, 10),
          formateDate: "yyyy/mm/dd",
        });
      } catch (e) {
        console.error("export error");
      }
    },
    addexpense() {
      this.$store.dispatch("expenses/add", this.expense_model);

      if (this.experrors == null) {
        this.$toast.success("Expense added successfully");

        this.expense_model = {
          ledgeracc_id: "",
          description: "",
          dr: 0.0,
          cr: 0.0,
          jdate: new Date().toISOString().substr(0, 10),
        };
      }
    },
    deleteexpense(expense, index) {
      if (confirm("Are you sure you want to delete this expense?")) {
        this.$store.dispatch("expenses/delete", { expense, index });
        this.$toast.success("Expense deleted successfully");
      }
    },

    editexpense(expense) {
      this.editedIndex = this.expenses.indexOf(expense);
      this.expense_model = Object.assign({}, expense);

      //alert(this.editedIndex)

      this.openExForm();
    },
    updateexpense(expense, index) {
      this.$store.dispatch("expenses/update", { index, expense });

      if (this.experrors == null) {
        this.editedIndex = -1;
        this.showD = false;
        this.$toast.success("Expense updated successfully");

        this.expense_model = {
          ledgeracc_id: "",
          description: "",
          dr: 0.0,
          cr: 0.0,
          jdate: new Date().toISOString().substr(0, 10),
        };
        this.closeExForm();

        //this.$store.dispatch("expenses/getAll", { type: 1 });

        //  setTimeout(()=>{
        //    window.location.reload();
        //  },100)
      } else {
        this.$toast.error(
          "Sorry, an error occured and expense data could not be updated."
        );
      }
    },
    saveexpense() {
      if (!this.$refs.form.validate()) {
        return;
      }
      //decides between editing expense info or saving expense info
      if (this.editedIndex > -1) {
        this.updateexpense(this.expense_model, this.editedIndex);
      } else {
        this.addexpense();
      }
    },

    openExForm() {
      var vm = this;
      if (this.editedIndex > -1) {
        this.fm_title = "Edit Expense";
      } else {
        this.fm_title = "Add Expense";
      }
      vm.$refs.incfm.IsPersistent();

      vm.$refs.incfm.open();
    },
    closeExForm() {
      var vm = this;
      this.expense_model = {
        ledgeracc_id: "",
        description: "",
        dr: "0.00",
        cr: "0.00",
        jdate: new Date().toISOString().substr(0, 10),
        cbt: false,
        bankacc_id: "",
      };

      vm.$refs.incfm.close();
    },
  },
  watch: {
    // showD(val) {
    //   if (val == false) {
    //     this.expense_model = {
    //       ledgeracc_id: "",
    //       description: "",
    //       dr: 0.0,
    //       cr: 0.0,
    //       jdate: new Date().toISOString().substr(0, 10)
    //     };
    //   }
    // }

    "expense_model.cbt": function (val) {
      if (val == false) {
        this.expense_model.bankacc_id = "";
      }
    },
  },
};
</script>